import { z } from 'zod';

// Zod 스키마 정의
export const loginSchema = z.object({
  passid: z
    .string()
    .nonempty({ message: '아이디를 입력해주세요.' })
    .min(2, { message: '2자리 이상이어야 합니다.' })
    .max(16, { message: '16자리 이하여야 합니다.' }),
  password: z
    .string()
    .nonempty({ message: '비밀번호를 입력해주세요.' })
    .min(8, { message: '비밀번호는 최소 8자 이상이어야 합니다.' }),
});
